 
/* eslint-disable no-invalid-this */
/* eslint-disable no-useless-escape */
 
/* eslint-disable no-unused-vars */
import $ from 'jquery';
import '../../jsscripts/jquery/jquery.validate.1.17.0.js';
import '../../jsscripts/jquery/jquery.validate.unobtrusive.min.modified.js';
import {isValidShipDate} from './unobtrusivehelpers.js';

function isHTML5Format(value) {
    return /\d{4}-\d{2}-\d{2}/gi.test(value);
}

function convertToDateFormat(value) {
    return value.replace(/-/gi, '/');
}

// -- SPE.Web.ViewModels.ValidationAttributes.SearchTermAttribute ------------------------------
$.validator.unobtrusive.adapters.add('searchterm', [], function (options) {
    options.rules['searchterm'] = {};
    options.messages['searchterm'] = options.message;
});

$.validator.addMethod('searchterm', function (value, element, parameters) {
    var url = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/,
        html = /[<>]/,
        watermark = /Enter Item \# or Keyword/;

    return !html.test(value) && !url.test(value) && !watermark.test(value);
});

$.validator.unobtrusive.adapters.add('searchterm', [], function (options) {
    options.rules['searchterm'] = {};
    options.messages['searchterm'] = options.message;
});

$.validator.addMethod('searchterm', function (value, element, parameters) {
    var url = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/,
        html = /[<>]/,
        watermark = /Enter Item \# or Keyword/;

    return !html.test(value) && !url.test(value) && !watermark.test(value);
});

// -- SPE.Web.ViewModels.ValidationAttributes.SearchTermAttribute ------------------------------

// -- SPE.Web.ViewModels.ValidationAttributes.ShipDateAttribute ------------------------------
$.validator.unobtrusive.adapters.add('shipdate', [], function (options) {
    options.rules['shipdate'] = {};
    options.messages['shipdate'] = options.message;
});

$.validator.addMethod('shipdate', function (value, element, parameters) {
    if (isHTML5Format(value)) {
        value = convertToDateFormat(value);
    }

    return isValidShipDate(value);
});
// -- SPE.Web.ViewModels.ValidationAttributes.ShipDateAttribute ------------------------------

$.validator.unobtrusive.adapters.add('addresscharacters', [], function (options) {
    options.rules['addresscharacters'] = {};
    options.messages['addresscharacters'] = options.message;
});

$.validator.addMethod('addresscharacters', function (value) {
    return !/\|/gi.test(value);
});

function getControlValue(id) {
    // note - this probably needs to cater for more
    // control types, e.g. radios
    var control = $(id),
        controltype = control.attr('type');
    return controltype === 'checkbox' ? control.is(':checked').toString() : control.val();
}

// -- SPE.Web.ViewModels.ValidationAttributes.RequiredIfAttribute ------------------------------
$.validator.unobtrusive.adapters.add('requiredif', ['dependentproperty', 'targetvalue'], function (options) {
    options.rules['requiredif'] = {
        dependentproperty: options.params['dependentproperty'],
        targetvalue: options.params['targetvalue']
    };
    options.messages['requiredif'] = options.message;
    options.rules['requiredif'] = options.params;
});

$.validator.addMethod('requiredif', function (value, element, parameters) {
    var id = '#' + parameters['dependentproperty'],
        // get the target value (as a string,
        // as that's what actual value will be)
        targetvalue = parameters['targetvalue'];
    targetvalue = (targetvalue == null ? '' : targetvalue).toString();

    // get the actual value of the target control
    var actualvalue = getControlValue(id);

    // if the condition is true, reuse the existing
    // required field validator functionality
    if (targetvalue === actualvalue) {
        return $.validator.methods.required.call(this, value, element, parameters);
    }

    return true;
});
// -- SPE.Web.ViewModels.ValidationAttributes.RequiredIfAttribute ------------------------------

// -- SPE.Web.ViewModels.ValidationAttributes.MustMatchAttribute ------------------------------
$.validator.unobtrusive.adapters.add('mustmatch', ['dependentproperty'], function (options) {
    options.rules['mustmatch'] = {
        dependentproperty: options.params['dependentproperty']
    };
    options.messages['mustmatch'] = options.message;
});

$.validator.addMethod('mustmatch', function (value, element, parameters) {
    var id = '#' + parameters['dependentproperty'],
        // get the actual value of the target control
        dependentPropertyValue = getControlValue(id);

    return value == dependentPropertyValue;
});
// -- SPE.Web.ViewModels.ValidationAttributes.MustMatchAttribute ------------------------------

// -- SPE.Web.ViewModels.ValidationAttributes.MustMatchIfAttribute ------------------------------
$.validator.unobtrusive.adapters.add(
    'mustmatchif',
    ['dependentproperty', 'ifpropertyname', 'ifpropertyvalue'],
    function (options) {
        options.rules['mustmatchif'] = {
            dependentproperty: options.params['dependentproperty'],
            ifpropertyname: options.params['ifpropertyname'],
            ifpropertyvalue: options.params['ifpropertyvalue']
        };
        options.messages['mustmatchif'] = options.message;
    }
);

$.validator.addMethod('mustmatchif', function (value, element, parameters) {
    var id = '#' + parameters['ifpropertyname'],
        // get the target value (as a string,
        // as that's what actual value will be)
        targetvalue = parameters['ifpropertyvalue'];
    targetvalue = (targetvalue == null ? '' : targetvalue).toString();

    var actualvalue = getControlValue(id);

    // if the condition is true, reuse the existing
    // mustmatch field validator functionality
    if (targetvalue === actualvalue) {
        return $.validator.methods.mustmatch.call(this, value, element, parameters);
    }

    return true;
});
// -- SPE.Web.ViewModels.ValidationAttributes.MustMatchIfAttribute ------------------------------

// -- SPE.Web.ViewModels.ValidationAttributes.MustMatchIfAttribute ------------------------------
$.validator.unobtrusive.adapters.add('regexif', ['dependentproperty', 'targetvalue', 'pattern'], function (options) {
    options.rules['regexif'] = {
        dependentproperty: options.params['dependentproperty'],
        targetvalue: options.params['targetvalue'],
        pattern: options.params['pattern']
    };
    options.messages['regexif'] = options.message;
});

$.validator.addMethod('regexif', function (value, element, parameters) {
    var id = '#' + parameters['dependentproperty'],
        // get the target value (as a string,
        // as that's what actual value will be)
        targetvalue = parameters['targetvalue'];
    targetvalue = (targetvalue == null ? '' : targetvalue).toString();

    // get the actual value of the target control
    var actualvalue = getControlValue(id);

    // if the condition is true, reuse the existing
    // required field validator functionality
    if (targetvalue === actualvalue) {
        return $.validator.methods.regex.call(this, value, element, parameters['pattern']);
    }

    return true;
});
// -- SPE.Web.ViewModels.ValidationAttributes.MustMatchIfAttribute ------------------------------

// -- SPE.Web.ViewModels.ValidationAttributes.RequiredIfRegexMatchAttribute ------------------------------
$.validator.unobtrusive.adapters.add(
    'requiredifregexmatch',
    ['dependentproperty', 'dependentvalidationpattern', 'validationpattern'],
    function (options) {
        options.rules['requiredifregexmatch'] = {
            dependentproperty: options.params['dependentproperty'],
            dependentvalidationpattern: options.params['dependentvalidationpattern'],
            validationpattern: options.params['validationpattern']
        };
        options.messages['requiredifregexmatch'] = options.message;
    }
);

$.validator.addMethod('requiredifregexmatch', function (value, element, parameters) {
    var id = '#' + parameters['dependentproperty'],
        // get the actual value of the dependant control
        dependentcontrolvalue = getControlValue(id),
        dependentregex = new RegExp(parameters['dependentvalidationpattern']),
        dependentresult = dependentregex.test(dependentcontrolvalue);

    if (dependentresult) {
        if (parameters['validationpattern']) {
            var re = new RegExp(parameters['validationpattern']),
                result = re.test(value);
            return result;
        }

        if (value === '') {
            return false;
        }

        return true;
    }

    return true;
});
// -- SPE.Web.ViewModels.ValidationAttributes.RequiredIfRegexMatchAttribute ------------------------------

//-- SmartPak.UI.Web.Common.Controller.Helpers.CreditCard ------------------------------
$.validator.unobtrusive.adapters.add('creditcard', ['acceptedcardtypes'], function (options) {
    options.rules['creditcard'] = {
        acceptedcardtypes: options.params['acceptedcardtypes']
    };
    options.messages['creditcard'] = options.message;
    options.rules['creditcard'] = options.params;
});

$.validator.addMethod('creditcard', function (value, element, parameters) {
    var originalCardNumber = $(element).data('original-card-number'),
        acceptedcardtypes = Number(parameters['acceptedcardtypes']);
    return smartPak.creditCard.validator.validateCardNumber(value, originalCardNumber, acceptedcardtypes);
});

// -- SPE.Web.ViewModels.ValidationAttributes.CreditCardDateAttribute ------------------------------
$.validator.unobtrusive.adapters.add(
    'creditcarddate',
    ['dependentmonthproperty', 'dependentyearproperty'],
    function (options) {
        options.rules['creditcarddate'] = {
            dependentmonthproperty: options.params['dependentmonthproperty'],
            dependentyearproperty: options.params['dependentyearproperty']
        };
        options.messages['creditcarddate'] = options.message;
        options.rules['creditcarddate'] = options.params;
    }
);

$.validator.addMethod('creditcarddate', function (value, element, parameters) {
    var month = document.getElementById(parameters['dependentmonthproperty']),
        year = document.getElementById(parameters['dependentyearproperty']),
        isValid = smartPak.creditCard.validator.validateCardDate(month.value, year.value),
        errorClass = 'card-validation-error';

    if (!isValid) {
        month.classList.add(errorClass);
        year.classList.add(errorClass);
    } else {
        month.classList.remove(errorClass);
        year.classList.remove(errorClass);
    }

    return isValid;
});

// -- SPE.Web.ViewModels.ValidationAttributes.CreditCardDateAttribute ------------------------------

// -- SPE.Web.ViewModels.ValidationAttributes.RequiredToBeTrueAttribute ------------------------------
$.validator.unobtrusive.adapters.addBool('mustbetrue');
$.validator.addMethod('mustbetrue', function (value, element, param) {
    return element.checked;
});

$.validator.unobtrusive.adapters.add('mustmatchvalue', ['targetvalue'], function (options) {
    options.rules['mustmatchvalue'] = {
        targetvalue: options.params['targetvalue']
    };
    options.messages['mustmatchvalue'] = options.message;
});
$.validator.addMethod('mustmatchvalue', function (value, element, param) {
    return value === param.targetvalue;
});
